module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digital-realities-vr-hotel-avalon.json
// module id = 425
// module chunks = 220509110208154